import { createContext } from 'react';

export const FilterableCardItemDataContext = createContext<unknown>(undefined);
